<script>
  import { createPopper } from '@popperjs/core'
  import { clickOutside } from '../utils.js'
  import { onDestroy, onMount, tick } from 'svelte'

  import filterClasses, { cssPrefix } from '../helper-classes.js'
  import ChromaPicker from '../ChromaPicker/ChromaPicker.svelte'

  let referenceElement
  let popperElement
  let popperInstance
  const popperOptions = {
    placement: 'bottom-start'
  }

  async function setShow(active) {
    show = active

    if (show) {
      await tick()
      if (referenceElement && popperElement)
        popperInstance = createPopper(referenceElement, popperElement, popperOptions)
    } else {
      destroyPopper()
    }
  }

  function destroyPopper() {
    if (popperInstance) {
      popperInstance.destroy()
      popperInstance = null
    }
  }

  function handleClick() {
    if (!disabled) setShow(!show)
  }

  onDestroy(() => {
    destroyPopper()
  })

  onMount(() => {
    setShow(show)
  })

  export let id = null
  export let color = null
  export let show = false
  export let disabled = false

  export let style = null
  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  const classes = [`${cssPrefix}color-swatch`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  const slots = $$slots
</script>

{#if slots && Object.prototype.hasOwnProperty.call(slots, 'default')}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div on:click|preventDefault={handleClick} {id} bind:this={referenceElement} role="button" tabindex="0">
    <slot {disabled} />
  </div>
{:else}
  <button
    class={classes.join(' ')}
    style="background-color: {color}; {style || ''}"
    on:click={handleClick}
    bind:this={referenceElement}
    {id}
    {disabled}
  />
{/if}
{#if show}
  <div
    class="popper"
    bind:this={popperElement}
    use:clickOutside
    on:click_outside={() => {
      setShow(false)
    }}
    style="display:inline-block"
    {id}
  >
    <div class="gl-color-picker">
      <ChromaPicker bind:color on:change />
    </div>
  </div>
{/if}
